import { render, staticRenderFns } from "./edit-template.vue?vue&type=template&id=4b3e2824&scoped=true"
import script from "./edit-template.vue?vue&type=script&lang=js"
export * from "./edit-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3e2824",
  null
  
)

export default component.exports